export const languages = ["en", "nl", "fr", "es"];
 
export const countries = ["NL", "BE", "FR", "UK", "ES"];